// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1OvER","title":"Images90_title__2ZMw8","images":"Images90_images__Rq9rp"};